import script from "./AModalConsentimento.vue?vue&type=script&setup=true&lang=ts"
export * from "./AModalConsentimento.vue?vue&type=script&setup=true&lang=ts"

import "./AModalConsentimento.vue?vue&type=style&index=0&id=4302cf84&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4302cf84"]])

export default __exports__